import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { InfoModule } from '../info/info.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LocalizePipe } from '../../localize/localize.pipe';
import { ActionButtonComponent } from './action-button/action-button.component';
import { BlogPostSectionComponent } from './blog-post-section/blog-post-section.component';
import { CardModule } from '../card/card.module';
import { CenterTextSectionComponent } from './center-text-section/center-text-section.component';
import { ContactHeaderSectionComponent } from './contact-header-section/contact-header-section.component';
import { CountingNumberComponent } from './counting-number/counting-number.component';
import { FollowUpButtonSectionComponent } from './follow-up-button-section/follow-up-button-section.component';
import { LinkListSectionComponent } from './link-list-section/link-list-section.component';
import { LogoGroupComponent } from './logo-group/logo-group.component';
import { PageListSectionComponent } from './page-list-section/page-list-section.component';
import { QuestionCollectionSectionComponent } from './question-collection/question-collection-section/question-collection-section.component';
import { QuestionCollectionCardComponent } from './question-collection/question-collection-card/question-collection-card.component';
import { SearchbarHeaderSectionComponent } from './searchbar-header-section/searchbar-header-section.component';
import { CmsBaseComponent } from './cms-base/cms-base.component';
import { ActionHeaderComponent } from './action-header/action-header.component';
import { ButtonSectionComponent } from './button-section/button-section.component';
import { StorybrandStepsComponent } from './storybrand-steps/storybrand-steps.component';
import { EmpathyStatementComponent } from './empathy-statement/empathy-statement.component';
import { AppearDirective } from './appear/appear.directive';
import { PageLoadComponent } from './page-load/page-load.component';
import { ErrorPageModule } from '../pages/error-page/error-page.module';
import { HubspotSectionComponent } from './hubspot-section/hubspot-section.component';
import { ActionHeaderTwoComponent } from './action-header-two/action-header-two.component';
import { SearchbarSectionComponent } from './searchbar-section/searchbar-section.component';
import { LinkTabSectionComponent } from './link-tab-section/link-tab-section.component';
import { InfoPageModule } from '../info-page/info-page.module';
import { BonusTableComponent } from './bonus-table/bonus-table.component';
import { CmsSectionWrapperComponent } from './cms-section-wrapper/cms-section-wrapper.component';
import { GoogleDefaultReviewComponent } from 'app/standalone-components/google-reviews/google-default-review/google-default-review.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { CustomCarouselComponent } from 'app/standalone-components/custom-carousel/custom-carousel.component';
import { UnescapePipe } from '../shared/pipes/unescape.pipe';
import { BindHTMLDirective } from '../shared/directives/bindHTML.directive';
import { ErrorComponent } from '../shared/error/error.component';
import { ButtonComponent } from '../shared/button/button.component';

@NgModule({
	declarations: [
		ActionButtonComponent,
		ActionHeaderComponent,
		ButtonSectionComponent,
		BlogPostSectionComponent,
		CenterTextSectionComponent,
		ContactHeaderSectionComponent,
		CountingNumberComponent,
		CmsBaseComponent,
		FollowUpButtonSectionComponent,
		HubspotSectionComponent,
		LinkListSectionComponent,
		LogoGroupComponent,
		PageListSectionComponent,
		QuestionCollectionSectionComponent,
		QuestionCollectionCardComponent,
		SearchbarHeaderSectionComponent,
		StorybrandStepsComponent,
		EmpathyStatementComponent,
		PageLoadComponent,
		AppearDirective,
		ActionHeaderTwoComponent,
		SearchbarSectionComponent,
		LinkTabSectionComponent,
		BonusTableComponent,
		CmsSectionWrapperComponent,
	],
	imports: [
		CardModule,
		InfoModule,
		ErrorPageModule,
		InfoPageModule,
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		LocalizePipe,
		MatDialogModule,
		MatTableModule,
		TranslateModule.forChild(),
		GoogleDefaultReviewComponent,
		CustomCarouselComponent,
		UnescapePipe,
		BindHTMLDirective,
		ErrorComponent,
		ButtonComponent
	],
	exports: [
		ActionButtonComponent,
		ActionHeaderComponent,
		ButtonSectionComponent,
		BlogPostSectionComponent,
		CenterTextSectionComponent,
		ContactHeaderSectionComponent,
		CountingNumberComponent,
		CmsBaseComponent,
		FollowUpButtonSectionComponent,
		HubspotSectionComponent,
		LinkListSectionComponent,
		LogoGroupComponent,
		PageListSectionComponent,
		QuestionCollectionSectionComponent,
		SearchbarHeaderSectionComponent,
		PageLoadComponent,
		AppearDirective,
		BonusTableComponent,
		SearchbarSectionComponent,
		CmsSectionWrapperComponent
	]
})
export class CmsModule { }
